module.exports = ".top-menu-secondary.with-overflow.color-scheme-dark.test{\n    background-color: rebeccapurple;\n}\n.top-menu-secondary.with-overflow.color-scheme-dark.local{\n    background-color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/_layout/header/header.component.css
// module id = ./src/app/_layout/header/header.component.css
// module chunks = main